import {rbbPost} from './api';
import {throwToast} from './rbb-common';

document.addEventListener('DOMContentLoaded', () => {
    const params = (new URL(document.location)).searchParams;
    const order = params.get('o');
    const hmac = params.get('hmac');
    const token = {order:order,hmac:hmac};
    rbbPost('/apps/rbbr/api/validateReadingToken', token).
        then(response=>response.json()).
        then(data=>{
            if(data.valid){
                setupForm();
            }else{
                document.getElementById('app').innerHTML = "<div class=\"alert alert--red\">Sorry, this request is not valid. Please check that the full URL has been copied from your welcome email; if the problem persists please contact Rare Birds.</div>";
            }
        });
});

const setupForm = () => {
    const params = (new URL(document.location)).searchParams;
    const order = params.get('o');
    const hmac = params.get('hmac');
    fetch('/?sections=reading-list-form').then(response=>response.json()).then(data=> {
        document.getElementById('app').innerHTML = data['reading-list-form'];
        document.getElementById('order_id').value = order;
        document.getElementById('hmac').value = hmac;
        document.getElementById('reading-list-questionnaire').addEventListener('submit', handleSubmit);
    });
};

const handleSubmit = (evt) => {
    evt.preventDefault();
    if(confirm("Once you click OK your answers will be sent to Rare Birds for processing: once your personalised list has been compiled you'll get an email to the address you entered on the form with your recommendations. If you need to change any of your answers click 'cancel' now, otherwise 'OK' to continue.")){
        const form = document.getElementById('reading-list-questionnaire');
        const formData = new FormData(form);
        const postData = Object.fromEntries(formData.entries());
        console.log(postData);
        rbbPost('/apps/rbbr/api/submitReadingList', postData).then(response=>response.json()).then(data=>{
            if(data.status < 300){
                throwToast(data.message, 'done');
                form.reset();
            }else{
                throwToast(data.message, 'error');
            }
        });
    }
};